module.exports = __webpack_public_path__ + "img/logo.c7b44930.png";